import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import { spacing, sizing, flexbox, display, borders } from '@material-ui/system';
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(0, 0, 3),
    },
}))

import Logo from '../../assets/img/imunis-logo.svg'

const Box = styled.div`${spacing}${sizing}${display}${flexbox}${borders}`;

const Brand = (props) => {
    const classes = useStyles()
    return (
        <Box display="flex" flexDirection="column" border={2} borderRadius={16} m={2} p={2}>
            <Box display="flex" flexDirection="column" >
                <Typography className={classes.margin} variant="h6" gutterBottom>
                    Logo
                </Typography>
                <img width='200px' src={Logo} />
            </Box>
        </Box>
    )
}

export default Brand